import React, { useState, useEffect, useCallback, memo } from "react"
import { nftData, categoryData } from "@util/hvoriginsData"
import CategoryItem from "./categoryItem"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import InfiniteScroll from "react-infinite-scroll-component"
import {
  faAlignLeft,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons"
import { getParsedNftAccountsByOwner } from "@nfteyez/sol-rayz"
import * as anchor from "@project-serum/anchor"
import { PropagateLoader } from "react-spinners"
import { connect } from "react-redux"
import { getNftMetaData } from "@util/dataHandler"
import { getReclaimableList } from "@util/stake"
import axios from "axios"
import Skeleton from "./skeleton"
import NFTItem from "./nftItem"
import "./GalleryPage.scss"
import NftModal from "./modal"
import { testWallet } from "@config/config"

// eslint-disable-next-line react/display-name
const SideBar = memo(props => {
  const [open, setOpen] = useState(true)
  let { filter, setFilter } = props
  const filterNft = data => {
    let buffer = filter.slice()
    if (
      buffer.filter(e => e.name === data.name && e.filter === data.filter)
        .length > 0
    ) {
      buffer.splice(
        buffer.findIndex(a => a.name === data.name && a.filter === data.filter),
        1
      )
      setFilter(buffer)
    } else {
      setFilter([...filter, data])
    }
  }
  const clearFilter = () => {
    setFilter([])
  }

  let isMounted
  const checkHorizontal = () => {
    if (isMounted) setOpen(window.innerWidth >= 1024 ? true : false)
  }

  useEffect(() => {
    isMounted = true
    checkHorizontal()
    window.addEventListener("resize", checkHorizontal)
    return () => {
      isMounted = false
      window.removeEventListener("resize", checkHorizontal)
    }
  }, [])

  return (
    <div
      className={`lg:show ${open ? "show" : "hide"
        } sidebar overflow-hidden  bg-white md:col-span-4 md:col-start-1 filter lg:col-span-3 relative rounded-r-3xl flex-right flex-col flex`}
    >
      <div className="w-full flex justify-between mt-5 px-10 items-center">
        <FontAwesomeIcon
          onClick={() => setOpen(false)}
          icon={faLongArrowAltLeft}
          size="2x"
          className={`lg:hidden  cursor-pointer  text-pink-500 ${open ? "block" : "hidden"
            }`}
        />
        <div className="hidden lg:block"></div>
        <div
          onClick={() => clearFilter()}
          className="cursor-pointer btnClear clear-btn rounded-full w-32 justify-center text-center flex z-20 text-white px-5 py-2 mt-2 font-barlow-italic"
        >
          Clear all
        </div>
        <FontAwesomeIcon
          onClick={() => setOpen(true)}
          icon={faAlignLeft}
          size="2x"
          className={`absolute right-2 cursor-pointer text-pink-500 lg:hidden ${open ? "hidden" : "block"
            } `}
        />
      </div>
      <div className="my-6 mx-auto px-2 pr-14 sm:px-14 w-full category-list overflow-y-scroll">
        {categoryData.map((data, idx) => (
          <div key={idx}>
            {<CategoryItem data={data} filter={filter} action={filterNft} />}
          </div>
        ))}
      </div>
    </div>
  )
})

const Collection = ({
  type,
  wallet
}) => {
  const itemsPerPage = 10
  const rpcHost = process.env.GATSBY_APP_SOLANA_RPC_HOST
  const connection = new anchor.web3.Connection(rpcHost)
  const [provider, setProvider] = useState(null)
  const [loading, setLoading] = useState(false)
  const [userNfts, setUserNtfs] = useState([])
  const [filteredNfts, setFilteredNfts] = useState([])
  const [visibleNfts, setVisibleNfts] = useState([])
  const [filter, setFilter] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [activeNft, setActiveNft] = useState(null)

  const escClickHandler = useCallback((event) => {
    if (event.keyCode === 27) {
      setOpenModal(false)
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escClickHandler);

    return () => {
      document.removeEventListener("keydown", escClickHandler);
    };
  }, [escClickHandler]);

  useEffect(() => {
    if (wallet !== null) {
      setProvider(new anchor.Provider(connection, wallet, "confirmed"))
    } else {
      setProvider(null)
      setUserNtfs([])
      setVisibleNfts([])
      setFilter([])
    }
  }, [wallet])

  useEffect(() => {
    let mnt = true
    if (filter.length === 0) {
      if (mnt) {
        setFilteredNfts(userNfts)
        setVisibleNfts(userNfts.slice(0, itemsPerPage))
      }
    } else {
      if (userNfts.length > 0) {
        let buffer = userNfts.slice()
        let viewbuffer = []
        buffer.map(data => {
          if (data !== undefined) {
            let visible = true
            filter.some(function (item) {
              if (
                data.metadata.attributes.filter(
                  e => e.trait_type === item.name && e.value === item.filter
                ).length === 0
              ) {
                visible = false
              }
            })
            if (visible) {
              viewbuffer.push(data)
            }
          }
        })
        if (mnt) {
          setFilteredNfts(viewbuffer)
          setVisibleNfts(viewbuffer.slice(0, itemsPerPage))
        }
      }
    }
    return () => (mnt = false)
  }, [filter])

  useEffect(() => {
    setFilteredNfts(userNfts)
  }, [userNfts])

  useEffect(() => {
    if (provider !== null) {
      setLoading(true)
      getUserNfts()
    }
  }, [provider])

  const fetchMoreData = () => {
    setTimeout(() => {
      setVisibleNfts(
        visibleNfts.concat(
          filteredNfts.slice(
            visibleNfts.length,
            visibleNfts.length + itemsPerPage
          )
        )
      )
    }, 1500)
  }

  const getUserNfts = async () => {
    let evolvedInfo = []
    let tmpIds = []
    let evolvedIds = await axios.get(
      "https://api.heroesandvillains.io/origins/evolved"
    )
    evolvedIds = evolvedIds.data.mints
    evolvedIds.map(item => {
      let str = item.split("-")
      let id = parseInt(str[0])
      let stage = parseInt(str[1])
      tmpIds[id] = {
        id: id,
        stage: stage,
      }
    })

    if (type === "mynfts") {
      let nfts = await getParsedNftAccountsByOwner({
        publicAddress: testWallet != "" ? testWallet : wallet.publicKey,
        connection: connection,
        serialization: true,
      })
      nfts.map(info => {
        if (info.data.symbol === "HVORIGINS") {
          let myNftId = Number(info.data.name.split("#").pop())
          if (tmpIds[myNftId]) evolvedInfo.push(tmpIds[myNftId])
        }
      })

      let stakedNfts = await getReclaimableList(provider)
      stakedNfts.map(item => {
        evolvedInfo.push({
          id: item.id,
          stage: 7,
        })
      })
    } else if (type === "explorer") {
      evolvedInfo = tmpIds
    }

    evolvedInfo = evolvedInfo.sort(sortId)
    setUserNtfs(getNftMetaData(evolvedInfo))
    setFilter([])
    setLoading(false)
  }

  const sortId = (a, b) => {
    if (a.id < b.id) {
      return -1
    }
    if (a.id > b.id) {
      return 1
    }
    return 0
  }

  useEffect(() => {
    if (activeNft !== null)
      setOpenModal(true)
  }, [activeNft])

  return (
    <div className="gallery-container">
      <div className="grid grid-cols-12">
        <SideBar filter={filter} setFilter={setFilter} />
        <div className=" col-start-2 lg:col-start-5 xl:col-start-4  col-span-10 lg:col-span-9 items-center relative gallery-view my-auto">
          <div
            className="nft-gallery text-xl md:text-2xl h-auto mb-2 pb-1 pt-5 md:pb-2 lg:pt-10 text-white px-5 md:px-16 max-w-126 mx-auto"
            style={{ minHeight: "auto" }}
          >
            Total Results: {filteredNfts.length}
          </div>
          <InfiniteScroll
            dataLength={visibleNfts.length}
            next={fetchMoreData}
            hasMore={visibleNfts.length < filteredNfts.length}
            loader={
              <div className="z-50">
                <PropagateLoader color={"#FFFFFF"} loading={true} size={30} />
              </div>
            }
            style={{ overflow: "false", textAlign: "center" }}
          >
            <div className="nft-gallery grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-10 px-5 md:pl-16 xl:pr-10 pb-10 max-w-126 mx-auto">
              {!loading &&
                visibleNfts.map(
                  (i, index) =>
                    i !== undefined &&
                    i.metadata !== undefined && (
                      <NFTItem item={i.metadata} key={index} index={index} itemClickHandler={(image, thumb) => {
                        setActiveNft({
                          data: i.metadata,
                          img: image,
                          thumb: thumb
                        })

                      }} />
                    )
                )}
              {loading && nftData.map((i, index) => <Skeleton key={index} />)}
            </div>
          </InfiniteScroll>
        </div>
      </div>
      <NftModal open={openModal} setOpen={setOpenModal} nftData={activeNft} />
    </div>
  )
}

const stateProps = (state) => ({
  wallet: state.wallet
});

export default connect(stateProps, null)(Collection);
